<template> 
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect stroke="currentColor" x="0.500061" y="0.5" width="23" height="23" rx="11.5" />
    <path fill="currentColor" d="M8.46455 9.64298C8.13911 9.31754 8.13911 8.7899 8.46455 8.46447C8.78999 8.13903 9.31762 8.13903 9.64306 8.46447L15.5356 14.357C15.8611 14.6825 15.8611 15.2101 15.5356 15.5355C15.2102 15.861 14.6825 15.861 14.3571 15.5355L8.46455 9.64298Z" />
    <path fill="currentColor" d="M14.3571 8.46447C14.6825 8.13903 15.2102 8.13903 15.5356 8.46447C15.8611 8.7899 15.8611 9.31754 15.5356 9.64298L9.64306 15.5355C9.31762 15.861 8.78999 15.861 8.46455 15.5355C8.13911 15.2101 8.13911 14.6825 8.46455 14.357L14.3571 8.46447Z" />
  </svg>
</template>

<style lang="scss" scoped>
  @import './styles.scss';
</style>